/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Sample prompts for a research session
 * @export
 * @interface ResearchSessionSamplePromptResponse
 */
export interface ResearchSessionSamplePromptResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ResearchSessionSamplePromptResponse
     */
    samplePrompts?: Array<string>;
}

/**
 * Check if a given object implements the ResearchSessionSamplePromptResponse interface.
 */
export function instanceOfResearchSessionSamplePromptResponse(value: object): value is ResearchSessionSamplePromptResponse {
    return true;
}

export function ResearchSessionSamplePromptResponseFromJSON(json: any): ResearchSessionSamplePromptResponse {
    return ResearchSessionSamplePromptResponseFromJSONTyped(json, false);
}

export function ResearchSessionSamplePromptResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResearchSessionSamplePromptResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'samplePrompts': json['sample_prompts'] == null ? undefined : json['sample_prompts'],
    };
}

export function ResearchSessionSamplePromptResponseToJSON(json: any): ResearchSessionSamplePromptResponse {
    return ResearchSessionSamplePromptResponseToJSONTyped(json, false);
}

export function ResearchSessionSamplePromptResponseToJSONTyped(value?: ResearchSessionSamplePromptResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sample_prompts': value['samplePrompts'],
    };
}

